<template>
  <div class="mt-10 px-8 text-center mb-5">
    <p class="mb-5">
      Você ainda não tem nenhum desafio por aqui! Vamos gerar um para começar?
    </p>
    <img src="@/assets/img/nochallenge.svg" alt="" class="mb-10" />
    <ChallengeGeneratorButton />
  </div>
</template>

<script>
import ChallengeGeneratorButton from "./ChallengeGeneratorButton.vue";
export default {
  name: "NoChallengesYet",
  components: { ChallengeGeneratorButton }
};
</script>
